// @ vendors
import React, { Fragment } from 'react';

const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
// @ commons
// @ components
const HasPEP = require('components/hasPEP/hasPEP');
const TaxationQuestions = require('components/taxationQuestions/taxationQuestions').TaxationQuestions;
const AccountMoney = require('components/accountMoney/accountMoney');
const AccountUse = require('components/accountUse/accountUse').accountUse;
const Patrimony = require('components/incomes/patrimony/patrimony');
const BlockWrapper = require('components/blockWrapper/blockWrapper');
import AnnualIncome from './questionBlock/AnnualIncome';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
// @ utilities
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { recordEventCustomOnly } from 'utilities/uTagging';
// @ actions
const accountTypeActions = require('actions/accountTypeActions');
import { CREDIT_CARD, LOAN } from 'constants/userProfile';
import { FiocTgssConsent } from './components/FiocTgssConsent';
import { goToErrorsView } from 'actions/errorViewNavigation';
import { getIsAuthorized } from 'utilities/jointHolders/holderTypes';

class pensioner extends React.Component {
    constructor(props) {
        super(props);
        this.onHandleSave = this.onHandleSave.bind(this);
        this.getProfessionalCategories = this.getProfessionalCategories.bind(this);
        this.buildAccountUse = this.buildAccountUse.bind(this);
        this.buildDefaultQuestions = this.buildDefaultQuestions.bind(this);
    }

    onHandleSave(name, value) {
        const { userProfile, goToErrorsView } = this.props;
        const data = {};
        const accessToken = userProfile.accessToken;
        data[name] = value;
        this.props.accountTypeActions.savePensionerInformation(data, accessToken, (saved, errors) => {
            if (!saved) {
                if (errors['6002']) {
                    goToErrorsView({ errorCode: 6002 });
                }
            }
        });
    }

    getProfessionalCategories() {
        return this.props.options.get('professionalCategories').map(value => {
            return value.toObject();
        });
    }

    buildAccountUse() {
        const { userProfile } = this.props;

        return (
            <AccountUse
                profileModel="userProfile.pensioner_accountUse"
                accountTypes={['personal', 'other']}
                hasPEP={userProfile['pensioner_hasPEP']}
                handleSave={this.onHandleSave}
                {...this.props}
            />
        );
    }

    buildDefaultQuestions() {
        const { userProfile, disabled, commonList, shouldRenderTgssQuestion, formActions, userProfileForm } =
            this.props;
        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(userProfile.investmentType);

        return (
            <div>
                <BlockWrapper position={0} visible={true}>
                    <div className="row">
                        <div className="col-sm-12 md-form-group">
                            <AnnualIncome
                                userProfile={userProfile}
                                disabled={disabled}
                                model={'pensioner'}
                                optionsList={commonList}
                                handleSave={this.onHandleSave}
                                onChange={() =>
                                    recordEventCustomOnly({
                                        categoriaEvento: 'interaccion en tu actividad',
                                        accionEvento: 'ingresos',
                                    })
                                }
                                {...this.props}
                            />
                        </div>
                    </div>
                </BlockWrapper>

                <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD] && !userInvestmentType[LOAN]}>
                    <Fragment>
                        <BlockWrapper position={1} visible={true} firstValue={userProfile.pensioner_annualIncomeAmount}>
                            <div className="row">
                                <div className="col-sm-12 md-form-group">
                                    <Patrimony handleSave={this.onHandleSave} {...this.props} />
                                </div>
                            </div>
                        </BlockWrapper>
                        <BlockWrapper position={2} visible={false} firstValue={userProfile.is_patrimony}>
                            <div className="row">
                                <div className="md-form-group col-sm-12">
                                    <HasPEP
                                        profileModel="userProfile.pensioner_hasPEP"
                                        {...this.props}
                                        handleSave={this.onHandleSave}
                                    />
                                </div>
                            </div>
                        </BlockWrapper>

                        <BlockWrapper position={3} visible={false} firstValue={userProfile.pensioner_hasPEP}>
                            <div className="row">
                                <div className="col-lg-12 md-form-group">
                                    <AccountMoney
                                        profileModel="userProfile.pensioner_accountMoney"
                                        {...this.props}
                                        handleSave={this.onHandleSave}
                                    />
                                </div>
                            </div>
                        </BlockWrapper>

                        <BlockWrapper position={4} visible={false} firstValue={userProfile.pensioner_accountMoney}>
                            <div className="row">
                                <div className="col-lg-12 md-form-group">{this.buildAccountUse()}</div>
                            </div>
                        </BlockWrapper>

                        <BlockWrapper position={5} visible={false} firstValue={userProfile.pensioner_accountUse}>
                            <div className="row">
                                <div className="md-form-group col-lg-12">
                                    <TaxationQuestions {...this.props} handleSave={this.onHandleSave} />
                                </div>
                            </div>
                        </BlockWrapper>

                        {shouldRenderTgssQuestion && (
                            <BlockWrapper position={5} visible={false} firstValue={userProfile.pensioner_accountUse}>
                                <div className="row">
                                    <div className="col-lg-12 md-form-group">
                                        <FiocTgssConsent
                                            formActions={formActions}
                                            userProfileForm={userProfileForm}
                                            userProfile={userProfile}
                                        />
                                    </div>
                                </div>
                            </BlockWrapper>
                        )}
                    </Fragment>
                </ConditionalToggling>
            </div>
        );
    }

    render() {
        const { userProfile } = this.props;
        const questios =
            userProfile.isJointHolder && getIsAuthorized(userProfile.jointHolderType)
                ? null
                : this.buildDefaultQuestions();

        return questios;
    }
}

module.exports.constructor = pensioner;
module.exports.pensioner = connect(
    state => ({
        extraData: state.extraData,
        options: state.options,
    }),
    dispatch => ({
        accountTypeActions: bindActionCreators(accountTypeActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(pensioner);
